export const blockIconsAudioandvideoPodcastsNew = (
	<span className='material-symbols-outlined'>podcasts</span>
);
